module.exports = __webpack_public_path__ + "static/alfastuc-design-5e6d4d86b498b5785f6416b2c4cbce3f.jpg";